import { useEffect, useState } from "react";
import { Link } from "@tanstack/react-router";
import { Badge, Card, PageHeader } from "@/components/primitives";
import { CosmosActionState, useCosmosClient } from "@/lib/cosmos-api";

export function ActionsPage() {
  const cosmos = useCosmosClient();
  const [actions, setActions] = useState<CosmosActionState[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    void cosmos
      .listActions()
      .then(setActions)
      .catch((err) =>
        setError(err instanceof Error ? err.message : "Failed to load actions")
      );
  }, [cosmos]);

  return (
    <div className="page">
      <PageHeader
        eyebrow="Actions"
        title="Approval queue"
        subtitle="Mutating Cosmos actions are routed through human approval."
      />
      {error && <Card className="error-card">{error}</Card>}
      <div className="stack">
        {actions.map((action) => (
          <Link key={action.requestId} to="/actions/$requestId" params={{ requestId: action.requestId }}>
            <Card className="row-card">
              <div>
                <h2>{action.actionType}</h2>
                <p>{action.reason ?? "No reason provided"}</p>
              </div>
              <Badge tone={action.status === "completed" ? "success" : "warning"}>
                {action.status}
              </Badge>
            </Card>
          </Link>
        ))}
      </div>
    </div>
  );
}
